<form (ngSubmit)="onSubmit()" [formGroup]="initialForm">
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      id="client-information"
      subtitle=""
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    (navigateBackClick)="previousRoute()"
    [clientId]="clientId"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [showBackButton]="true"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [totalReviews]="_totalReviews"
  />
  <div class="external-report-heading flip-report-form">
    <div class="header-text">
      {{
        'Progress Report Form: Functional Listening Index-Paediatric'
          | translate
      }}
    </div>
    <div class="logo">
      <img [src]="path" alt="FLI-P logo" class="flip-logo" />
    </div>
  </div>
  <div class="client-details" class="flip-report-form">
    <strong>{{ 'Date' | translate }}:</strong>
    {{ _todayDate | date: 'dd/MM/yyyy' }}
  </div>
  <div class="client-details" class="flip-report-form">
    <strong>{{ 'Name' | translate }}:</strong> {{ _clientName }}
    <strong>Age:</strong> {{ _age }}
    <strong>{{ 'Date of Birth' | translate }} :</strong> {{ _dob }}
  </div>
  <div class="assessment-info flip-report-form">
    <p>{{ _clientName }}'s {{ 'Flip Report Comment' | translate }}</p>
    <p>
      {{ _clientName }}'s' {{ 'Flip Report Comment 2' | translate }}
      {{ _clientName }}'s {{ 'Flip Report Comment 3' | translate }}
      {{ _clientName }}'s {{ 'Flip Report Comment 4' | translate }}
      {{ _score }}/64 {{ 'items' | translate }}
    </p>
  </div>
  <div>
    <div class="assessment-headline">
      {{ 'Recent listening skills gained' | translate }}
    </div>
    <div
      *ngFor="let dropdown of dropdowns; let i = index"
      class="flip-report-form"
    >
      <app-dropdown
        [control]="dropdown.control"
        [data]="dropdown.data"
        [id]="'dropdown' + (i + 1)"
        [label]="dropdown.label"
      >
      </app-dropdown>
    </div>

    <div class="assessment-headline">
      {{ 'Next skills to develop' | translate }}
    </div>
    <div
      *ngFor="let dropdown of rareDropdown; let i = index"
      class="flip-report-form"
    >
      <app-dropdown
        [control]="dropdown.control"
        [data]="dropdown.data"
        [id]="'rareDropdown' + (i + 1)"
        [label]="dropdown.label"
      >
      </app-dropdown>
    </div>
    <div class="contact-info-footer">
      <div class="clinician-info">
        <div class="input-info">
          <label for="clinicianName"
            ><strong>{{ 'Clinician name' | translate }}</strong></label
          >
          <input
            class="text-input"
            formControlName="clinicianName"
            id="clinicianName"
            placeholder="{{ 'Enter clinician name' | translate }}"
            type="text"
          />
        </div>
        <div class="input-info">
          <label for="title"
            ><p>
              <strong>{{ 'Title Role' | translate }}</strong>
            </p></label
          >
          <input
            class="text-input"
            formControlName="title"
            id="title"
            placeholder="{{ 'Enter Role' | translate }}"
            type="text"
          />
        </div>
      </div>
      <div class="report-hearhub-logo">
        <app-hearhub-logo
          [inverted]="false"
          class="login-brand-logo"
        ></app-hearhub-logo>
      </div>
    </div>
    <div class="flip-report-button">
      <button type="submit">{{ 'Generate report details' | translate }}</button>
    </div>
  </div>
</form>
